import React, {
  useState,
} from "react";
import {
  useDispatch,
  useSelector,
} from "react-redux";
import {
  Link as RouterLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  Link,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";

import {
  forgotPassword,
  login,
  resendVerificationEmail,
} from "../redux/auth/authActions";

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();

  const [email, setEmail] = useState(
  location.state?.verificationEmail || ""
);
  const [password, setPassword] =
    useState("");

  const { error, loading } = useSelector(
    (state) => state.auth
  );

  const verificationRequired =
    location.state?.verificationRequired === true;

  const handleSubmit = (event) => {
    event.preventDefault();

    dispatch(
      login(
        email,
        password,
        navigate,
        toast
      )
    );
  };
const approvalPending =
  location.state?.approvalPending === true;

const verificationEmailSent =
  Boolean(
    location.state?.verificationEmail
  ) &&
  !verificationRequired &&
  !approvalPending;
  const handleForgotPassword = () => {
    dispatch(
      forgotPassword(email, toast)
    );
  };
const handleResendVerification = () => {
  dispatch(
    resendVerificationEmail(
      email,
      password,
      toast
    )
  );
};
  return (
    <Box
      bg="white"
      maxW="800px"
      mx="auto"
      mt={10}
      p={{ base: 5, md: 6 }}
      borderWidth={1}
      borderRadius="lg"
      shadow="sm"
    >
      <Flex align="center" mb={6}>
        <Image
          src="/assets/logo.png"
          alt="Capital Project"
          width="300px"
          maxW="100%"
        />
      </Flex>

      <Text
        fontSize="2xl"
        fontWeight="bold"
        mb={6}
      >
        Sign In
      </Text>

      <form onSubmit={handleSubmit}>
        <VStack spacing={4}>
          {verificationEmailSent && (
  <Alert status="success">
    <AlertIcon />

    A verification email was sent to{" "}
    {location.state.verificationEmail}.
    Open the link before signing in.
  </Alert>
)}

{approvalPending && (
  <Alert status="info">
    <AlertIcon />

    Your email has been verified. Your
    account is waiting for administrator
    approval.
  </Alert>
)}
          {verificationRequired && (
            <Alert status="warning">
              <AlertIcon />

              Verify your email address before
              accessing the application.
            </Alert>
          )}

          {error && (
            <Alert status="error">
              <AlertIcon />
              {error}
            </Alert>
          )}

          <FormControl isRequired>
            <FormLabel>Email</FormLabel>

            <Input
              type="email"
              value={email}
              onChange={(event) =>
                setEmail(event.target.value)
              }
              autoComplete="email"
              disabled={loading}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Password</FormLabel>

            <Input
              type="password"
              value={password}
              onChange={(event) =>
                setPassword(event.target.value)
              }
              autoComplete="current-password"
              disabled={loading}
            />
          </FormControl>

          <Button
            type="submit"
            colorScheme="blue"
            isLoading={loading}
            loadingText="Signing In"
            width="full"
          >
            Sign In
          </Button>

          <Button
            type="button"
            variant="link"
            colorScheme="blue"
            onClick={handleForgotPassword}
            isDisabled={loading}
          >
            Forgot Password?
          </Button>

          <Text fontSize="sm">
            Need an account?{" "}
            <Link
              as={RouterLink}
              to="/register"
              color="blue.600"
              fontWeight="semibold"
            >
              Register
            </Link>
          </Text>
        </VStack>
      </form>
    </Box>
  );
};

export default LoginForm;